import { parseSurfaceM2 } from './surfaceDisplay';

export const BUILT_FOOTPRINT_TOOLTIP =
  'Representa la superficie cubierta en planta según datos satelitales. No refleja pisos ni superficie total construida.';

export const MAX_FOOTPRINT_TOOLTIP =
  'Valor estimado según normativa vigente. No contempla excepciones ni convenios urbanísticos particulares.';

export const MAX_BUILDABLE_TOOLTIP =
  'Valor estimado según normativa vigente. No contempla excepciones ni convenios urbanísticos particulares. El cálculo de pisos es estimado (altura / 3 m).';

/** Parsea m² de huella / superficie construida. null si no es numérico. */
export const parseFootprintM2 = (value) => {
  const m2 = parseSurfaceM2(value);
  return Number.isNaN(m2) ? null : m2;
};

const formatDecimalAR = (value, decimals = 0) => new Intl.NumberFormat('es-AR', {
  minimumFractionDigits: decimals,
  maximumFractionDigits: decimals,
}).format(value);

/** Siempre en m² (sin conversión a ha; eso solo aplica a Superficie en Información principal). */
const formatFootprintM2Label = (valueM2) => {
  const m2 = parseFootprintM2(valueM2);
  if (m2 === null) return '—';
  return `${formatDecimalAR(m2, 2)} m²`;
};

const buildMissingDisplay = () => ({
  valueLabel: 'Sin dato',
  muted: true,
});

/** Valores normativos pre-calculados en backend (`max_*_m2`). */
const getBackendFootprintPanelDisplay = (valueM2) => {
  if (valueM2 === null || valueM2 === undefined || valueM2 === '') {
    return buildMissingDisplay();
  }

  const m2 = parseFootprintM2(valueM2);
  if (m2 === null || m2 <= 0) {
    return buildMissingDisplay();
  }

  return { valueLabel: formatFootprintM2Label(m2), muted: false };
};

/**
 * Huella construida (`built_footprint_m2`).
 * > 0 → m²; = 0 → texto neutral; NULL → Sin dato.
 */
export const getBuiltFootprintPanelDisplay = (builtFootprintM2) => {
  if (builtFootprintM2 === null || builtFootprintM2 === undefined || builtFootprintM2 === '') {
    return { valueLabel: 'Sin dato', muted: true };
  }

  const m2 = parseFootprintM2(builtFootprintM2);
  if (m2 === null) {
    return { valueLabel: 'Sin dato', muted: true };
  }

  if (m2 === 0) {
    return { valueLabel: 'Sin construcción detectada', muted: true };
  }

  return { valueLabel: formatFootprintM2Label(m2), muted: false };
};

/** Huella máxima permitida (`max_footprint_m2`). */
export const getMaxFootprintPanelDisplay = (maxFootprintM2) => (
  getBackendFootprintPanelDisplay(maxFootprintM2)
);

/** Potencial constructivo total (`max_buildable_m2`). */
export const getMaxBuildablePanelDisplay = (maxBuildableM2) => (
  getBackendFootprintPanelDisplay(maxBuildableM2)
);

const toEdificabilidadRow = (id, label, display, tooltip) => ({
  id,
  label,
  displayText: display.valueLabel,
  group: 'edificabilidad',
  format: 'text',
  unit: null,
  highlight: false,
  muted: display.muted,
  tooltip,
});

/** Filas de edificabilidad (datos del lote, pre-calculados en backend). */
export const buildEdificabilidadDisplayRows = ({
  builtFootprintM2 = null,
  maxFootprintM2 = null,
  maxBuildableM2 = null,
} = {}) => [
  toEdificabilidadRow(
    'built_footprint_m2',
    'Huella construida',
    getBuiltFootprintPanelDisplay(builtFootprintM2),
    BUILT_FOOTPRINT_TOOLTIP,
  ),
  toEdificabilidadRow(
    'max_footprint_m2',
    'Huella máxima permitida',
    getMaxFootprintPanelDisplay(maxFootprintM2),
    MAX_FOOTPRINT_TOOLTIP,
  ),
  toEdificabilidadRow(
    'max_buildable_m2',
    'Potencial constructivo total',
    getMaxBuildablePanelDisplay(maxBuildableM2),
    MAX_BUILDABLE_TOOLTIP,
  ),
];
